import type { FC, SVGProps } from 'react';
import TreeIcon from './TreeIcon';
import BushIcon from './BushIcon';
import FlowerIcon from './FlowerIcon';
import ShrubIcon from './ShrubIcon';
import VegetablePatchIcon from './VegetablePatchIcon';
import PathRockIcon from './PathRockIcon';
import BuildingIcon from './BuildingIcon';
import LakeIcon from './LakeIcon';

// Point-icon types (tree, bush, ...) size themselves off a single `size` prop;
// resizable types (building, lake) read `width`/`height` off SVGProps directly.
export type IconProps = SVGProps<SVGSVGElement> & { size?: number };

export const ICONS_BY_TYPE: Record<string, FC<IconProps>> = {
  tree: TreeIcon,
  bush: BushIcon,
  flower: FlowerIcon,
  shrub: ShrubIcon,
  vegetablePatch: VegetablePatchIcon,
  pathRock: PathRockIcon,
  building: BuildingIcon,
  lake: LakeIcon,
};
